import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import UserSearch from '../common/UserSearch';
import { ISearchResult } from '../_types/search';
import { usePromiseTracker } from 'react-promise-tracker';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { useHistory } from 'react-router-dom';

interface Props {

};


const MemberHome: React.FC<Props> = (prop: Props) => {
    const { user } = useContext(AuthContext);

    const [selection, setSelection] = useState<ISearchResult | null>(null);
    const { promiseInProgress } = usePromiseTracker();
    const history = useHistory();

    const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        spinner: {
            marginLeft: 5,
            color: 'primary',
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        selectEmpty: {
            marginTop: theme.spacing(2)
        },
        header: {
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(1)
        }
        }),
    );
    const classes = useStyles();


    const _selectResult = (result: ISearchResult | null) => {
        setSelection(result);

        if (result) {
            let id: number = result.id;
            history.push(`/members/member/${id}`);
        }

    };

    return (
        <Grid container direction="column" justify="flex-start" alignItems="stretch">
            <Grid item>
                <Grid container direction="row" justify="flex-start" alignItems="stretch">
                    <Grid item>
                        <UserSearch onChange={(v) => _selectResult(v)}></UserSearch>
                    </Grid>
                    {promiseInProgress && (
                        <Grid item>
                            <CircularProgress className={classes.spinner} color="inherit"/>
                        </Grid>
                    )
                    }
                
                </Grid>
            </Grid>
        </Grid>
    )
}

export default MemberHome;